module.exports = __webpack_public_path__ + "img/botao_paracatu.f7e2f3fb.png";